import React, {useState, useRef, useEffect} from "react";
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";
import {Toast} from "primereact/toast";
import Spinner from "../../spinner/Spinner";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import {Tooltip} from "primereact/tooltip";
import {Button} from "primereact/button";
import {Tag} from "primereact/tag";
import {Dialog} from "primereact/dialog";
import {Badge} from "primereact/badge";
import axios from "axios";
import {OverlayPanel} from "primereact/overlaypanel";
import {Message} from "primereact/message";
import {Chip} from "primereact/chip";


const MyCreditApplications = props => {
    const toast = useRef(null);
    const [loadingState, setLoadingState] = useState(false);
    const [applications, setApplications] = useState([]);
    const [descriptionDialog, setDescriptionDialog] = useState(false);
    const [descriptionDialogHeader, setDescriptionDialogHeader] = useState("");
    const [descriptionDialogContent, setDescriptionDialogContent] = useState("");
    const [credit, setCredit] = useState(null);
    const [cpuLimit, setCpuLimit] = useState(null);
    const [gpuLimit, setGpuLimit] = useState(null);
    const [ramLimit, setRamLimit] = useState(null);
    const [diskLimit, setDiskLimit] = useState(null);
    const op = useRef(null);

    useEffect(() => {
        getApplications();
        getSourceLimits();
    }, []);

    const showSuccess = (message) => {
        toast.current.show({severity: 'success', summary: message, life: 3000});
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            life: 3000
        });
    }

    const getApplications = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            setLoadingState(true);
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/credit/", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        const data = res.data;
                        if (data.result) {
                            setApplications(data.applications);
                        } else {
                            // showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const getSourceLimits = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        // setLoadingState(true);
        axios.get('api/user-limits/', {"headers": headers, method: "GET"})
            .then(res => {
                // setLoadingState(false);
                const data = res.data;
                if (data.result) {
                    if (data.limits["credit"] == null) {
                        setCredit(0);
                    } else {
                        setCredit(data.limits["credit"]);
                    }
                    setCpuLimit(data.limits["cpu_limit"]);
                    setGpuLimit(data.limits["gpu_limit"]);
                    setRamLimit(data.limits["ram_limit"]);
                    setDiskLimit(data.limits["disk_limit"]);
                } else {
                    setCredit(0);
                }
            })
    }

    const getApplicationBody = (compute_key, compute_name) => {
        const applicationBody = (rowData) => {
            return (
                <React.Fragment>
                    <div>
                        <div className="p-grid">
                            <div className="p-col-12">
                                <span className="p-column-title">{compute_name}</span>
                            </div>
                            <div className="p-col-12" style={{wordBreak: "break-all"}}>
                                {rowData[compute_key] ? rowData[compute_key] : <span>-</span>}
                            </div>
                        </div>
                    </div>

                </React.Fragment>
            );
        }
        return applicationBody;
    }

    const creditStateBody = (rowData) => {
        let btn_type = "p-button-text";
        let icon_type = "pi";
        if (rowData["controller_result_code"] == "pending") {
            btn_type = "warning";
            icon_type = "pi pi-spin pi-spinner"
        } else if (rowData["controller_result_code"] == "accepted") {
            btn_type = "success";
            icon_type = "pi pi-check"
        } else if (rowData["controller_result_code"] == "rejected") {
            btn_type = "danger";
            icon_type = "pi pi-times"
        }
        return (
            <React.Fragment>
                <div>
                    <div className="p-grid">
                        <div className="p-col-12">
                            <span className="p-column-title">TALEP DURUMU</span>
                        </div>
                        <div className="p-col-12" style={{wordBreak: "break-all"}}>
                            <Tag className="mr-2" icon={icon_type} severity={btn_type} value={rowData["controller_result"]}
                                 rounded/>
                        </div>
                    </div>
                </div>

            </React.Fragment>
        );
    }

    const descriptionDialogOnDisplay = (header, content) => {
        setDescriptionDialogHeader(header);
        setDescriptionDialogContent(content);
        setDescriptionDialog(true);
    }

    const descriptionDialogOnHide = () => {
        setDescriptionDialogHeader("");
        setDescriptionDialogContent("");
        setDescriptionDialog(false);
    }

    const getDescriptionBody = (key, title) => {
        const descriptionBody = (rowData) => {
            return (
                <React.Fragment>
                    <div>
                        <div className="p-grid">
                            <div className="p-col-12">
                                <span className="p-column-title">{title}</span>
                            </div>
                            <div className="p-col-12" style={{wordBreak: "break-all"}}>
                                {rowData[key]
                                    ?
                                    rowData[key].length > 20
                                        ?
                                        <div>
                                            {rowData[key].substring(0, 20) + "..."}
                                            <Button label="Devamını Oku"
                                                    onClick={(e) => descriptionDialogOnDisplay(title, rowData[key])}
                                                    className="p-button-text"
                                            />
                                        </div>
                                        :
                                        rowData[key]
                                    :
                                    <span><b>-</b></span>
                                }
                            </div>
                        </div>
                    </div>

                </React.Fragment>
            );
        }
        return descriptionBody;
    }

    return (
        <div className='p-fluid'>
            <Toast ref={toast}/>
            <Spinner loadingState={loadingState}/>

            <div className="p-grid p-mb-5">
                <div className="p-col-12 p-sm-12 p-md-3 p-lg-2 p-xl-2">
                    <Button label="Kaynak Limiti"
                            icon="pi pi-angle-double-right"
                            className="p-button-text p-button-raised p-button-rounded"
                            iconPos="right"
                            disabled
                    />
                </div>
                <div className="p-col-12 p-md-1">
                    <Button label={cpuLimit ? "CPU : " + cpuLimit : <span>CPU : -</span>}
                            icon="pi pi-info-circle"
                            style={{fontSize: '11px'}}
                            className="p-button-success p-button-text"/>
                </div>
                <div className="p-col-12 p-md-1">
                    <Button label={gpuLimit ? "GPU : " + gpuLimit : <span>GPU : -</span>}
                            icon="pi pi-info-circle"
                            style={{fontSize: '11px'}}
                            className="p-button-success p-button-text"/>
                </div>
                <div className="p-col-12 p-md-1">
                    <Button label={ramLimit ? "RAM : " + ramLimit : <span>RAM : -</span>}
                            icon="pi pi-info-circle"
                            style={{fontSize: '11px'}}
                            className="p-button-success p-button-text"/>
                </div>
                <div className="p-col-12 p-md-1">
                    <Button label={diskLimit ? "DİSK : " + diskLimit : <span>DİSK : -</span>}
                            icon="pi pi-info-circle"
                            style={{fontSize: '11px'}}
                            className="p-button-success p-button-text"/>
                </div>
                <div className="p-col-12 p-sm-12 p-md-1 p-lg-4 p-xl-4"></div>
                <div className="p-col-12 p-sm-12 p-md-4 p-lg-2 p-xl-2" align="right">
                    <Button label="Mevcut Krediniz" icon="pi pi-money-bill"
                            className="p-button-rounded p-button-info"
                            disabled>
                        <Tag className="p-ml-2" severity="warning" style={{fontSize: '12px'}} value={credit}></Tag>
                    </Button>
                </div>
            </div>

            <div className="datatable-responsive-demo">
                <div className='card'>
                    <DataTable
                        value={applications}
                        className='p-datatable-responsive-demo'
                        paginator
                        rows={10}
                        header="KREDİ TALEPLERİM"
                        emptyMessage="Kayıt Bulunamadı"
                    >
                        <Column field="controller_result"
                                header="Talep Durumu"
                                body={creditStateBody}
                                style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                        />
                        <Column field="reason"
                                header="Talep Açıklaması"
                                body={getDescriptionBody("reason", "Talep Açıklaması")}
                                style={{textAlign: 'center', width: '5.5em'}}
                        />
                        <Column field="application_time"
                                header="Başvuru Zamanı"
                                body={getApplicationBody("application_time", "Başvuru Zamanı")}
                                style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                        />
                        <Column field="requested_credit"
                                header="Talep Edilen Kredi"
                                body={getApplicationBody("requested_credit", "Talep Edilen Kredi")}
                                style={{textAlign: 'center', width: '5.5em'}}
                        />
                        <Column field="applied_credit"
                                header="Onaylanan Kredi"
                                body={getApplicationBody("applied_credit", "Onaylanan Kredi")}
                                style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                        />
                        <Column field="control_description"
                                header="Kontrol Açıklaması"
                                body={getDescriptionBody("control_description", "Kontrol Açıklaması")}
                                style={{textAlign: 'center', width: '5.5em'}}
                        />
                    </DataTable>
                </div>
            </div>

            <Dialog visible={descriptionDialog}
                    onHide={descriptionDialogOnHide}
                    header={descriptionDialogHeader}
                    style={{width: '75%'}}
                    dismissableMask
            >
                <div className="p-grid">
                    <div className="p-col-12">
                        {descriptionDialogContent}
                    </div>
                </div>
            </Dialog>

            <OverlayPanel ref={op} showCloseIcon id="source_limit" style={{width: '450px'}}
                          className="overlaypanel-demo">
                <div className="p-grid">
                    <div className="p-col-12 p-md-3">
                        <Message severity="info" text={"CPU : " + cpuLimit}/>
                    </div>
                </div>
            </OverlayPanel>
        </div>
    );


}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(MyCreditApplications);


// WEBPACK FOOTER //
// ./src/pages/systemmanagement/My-CreditApplications.jsx